export default function Footer() {
  return (
    <footer className="bg-violet-500 text-white py-6 text-center text-sm">
      © {new Date().getFullYear()} Sleepwell baby cradle springs. All rights reserved.
    </footer>
  );
}
